import React from 'react'

function Loader({ w = 10, h = 10, bg }) {
    return (
        <div className={"animate-pulse rounded-full bg-cyan-600 h-" + h + " w-" + w + " shadow"} style={{ backgroundColor: bg ? bg : null }}></div>
    )
}

export default Loader